import { Component, OnInit } from "@angular/core";
import {
  NavController,
  NavParams,
  LoadingController,
  ModalController,
  IonicModule,
} from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { PessoaProvider } from "src/app/services/pessoa/pessoa";
import { UserProvider } from "src/app/services/user/user";
import { ModalPessoaPage } from "../modal-pessoa.page";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { ImagePipe } from "src/app/pipes/image/image";
import { SemRegistroComponent } from "src/app/components/sem-registro/sem-registro";
import { LoadingSpinnerComponent } from "src/app/components/loading/loading-spinner/loading-spinner.component";

@Component({
  selector: "app-modal-pessoa-familiares",
  templateUrl: "./modal-pessoa-familiares.page.html",
  styleUrls: ["./modal-pessoa-familiares.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ImagePipe,
    TranslateModule,
    SemRegistroComponent,
    LoadingSpinnerComponent,
  ],
})
export class ModalPessoaFamiliaresPage implements OnInit {
  familiares: any = [];
  visualizar: boolean;
  loaded: boolean = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingController: LoadingController,
    public pessoaProvider: PessoaProvider,
    public modalCtrl: ModalController,
    public userProvider: UserProvider,
    private translate: TranslateService
  ) {
    this.pessoaProvider
      .getFamiliaresbyId(this.navParams.get("idPessoa"))
      .subscribe((data) => {
        this.familiares = data;
      });
    this.visualizar = this.userProvider.hasPermissao("PESSOA_VISUALIZAR");
  }

  ngOnInit() {
    setTimeout(() => {
      this.loaded = true;
    }, 1000);
  }

  async selecionar(familiar: any) {
    if (this.familiares) {
      var modalPessoa = await this.modalCtrl.create({
        component: ModalPessoaPage,
        componentProps: {
          idPessoa: familiar.id,
          membro: this.navParams.get("membro"),
          autorizado: familiar.autorizado,
        },
      });
      modalPessoa.present();
    }
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
